module.exports = __webpack_public_path__ + "img/add-answer.6b7c1475.svg";